import * as React from 'react';
import cx from 'classnames';
import Link from '@src/components/link';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
const styles = require('./index.less');
const lang = getLanguageByPath();

const BTN_BG_MAP = {
  pc: require(`./images/${lang}/text-pc.png`),
  steam: require(`./images/${lang}/text-steam.png`),
  xbox: require(`./images/${lang}/text-xbox.png`)
};

const DownloadBtn = ({ link, method }) => {
  const renderBtn = () => {
    return (
      <div className={cx(styles.downloadBtn, styles[method])}>
        <div className={styles.text} style={{ backgroundImage: `url(${BTN_BG_MAP[method]})` }} />
        <div className={styles.arrow} />
        <div className={styles.hover}>
          <div className={styles.left}>
            <div className={styles.inner} />
          </div>
          <div className={styles.right}>
            <div className={styles.inner} />
          </div>
        </div>
      </div>
    );
  };

  return (
    <Link href={link} className={styles.root}>
      {renderBtn()}
      {renderBtn()}
    </Link>
  );
};

export default DownloadBtn;
